import "react-app-polyfill/ie9";

import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom";

import "./styles.css";

const Test = lazy(() => import("./test"));

function App() {
  return (
    <div className="App">
      <Suspense fallback={"...loading"}>
        <Test />
      </Suspense>
    </div>
  );
}

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
